import { render, staticRenderFns } from "./PendingHistoryLayout.vue?vue&type=template&id=1aba3f86"
import script from "./PendingHistoryLayout.vue?vue&type=script&lang=js"
export * from "./PendingHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports